import { useOpenRequestMemo } from '@hooks/Services';
import { Error, Loading } from '@organisms/Feedbacks';
import React, { useEffect } from 'react';
import styled from 'styled-components';

type Props = {
    formData: FormData;
    onSubmitComplete: any;
};
type FormData = {
    swOpenRequestId: any;
    memoContent: string;
    createUser: string;
    timestamp: number;
};

const SubmitForm = (props: Props) => {
    const { formData, onSubmitComplete } = props;
    const { error, loading } = useOpenRequestMemo.usePostData(formData);
    useEffect(() => {
        (!loading && !error && (onSubmitComplete()));
    });
    return (
        <FormWithStyled>
            {loading && <Loading />}
            {error && <Error />}
        </FormWithStyled>
    );
};

const FormWithStyled = styled.form`
    margin: 5px 0 0;
`

export default SubmitForm;